import {SearchHistoryProps} from "widgets/searchModal/model/props.ts";
import {FC} from "react";
import {
    HistoryBody, HistoryCloseButton,
    HistoryElement,
    HistoryHeader,
    HistoryHeaderErase,
    HistoryHeaderTitle
} from "widgets/searchModal/ui/styles.ts";
import {CloakIcon} from "shared/ui/icons/cloakIcon.tsx";
import {CloseIcon} from "shared/ui/icons";


export const SearchHistory:FC<SearchHistoryProps> = ({history, onHistoryClick, onHistoryDelete, onHistoryErase}) => {

    if (!history) return;

    return (
        <>
            <HistoryHeader>
                <HistoryHeaderTitle>История</HistoryHeaderTitle>
                <HistoryHeaderErase onClick={onHistoryErase}>
                    Очистить
                </HistoryHeaderErase>
            </HistoryHeader>
            <HistoryBody>
                {history.map((el) => {
                    return(
                        <HistoryElement onClick={() => onHistoryClick(el)}>
                            <CloakIcon/>
                            {el}
                            <HistoryCloseButton onClick={(e) => {
                                e.stopPropagation();
                                onHistoryDelete(el)
                            }
                            }>
                                <CloseIcon/>
                            </HistoryCloseButton>
                        </HistoryElement>
                    )
                })}
            </HistoryBody>
        </>
    );
};
